/**
 * Bật/tắt SEO + GEO theo môi trường.
 *
 * Chỉ khi APP_URL trỏ tới domain prod (anthu.vn) thì site mới cho Google / AI bot index.
 * DEV, UAT, localhost... => tự động chặn (robots.txt Disallow all, X-Robots-Tag noindex,
 * meta robots noindex, llms.txt 404). Không cần sửa .env hay masterdata ở từng môi trường.
 *
 * Thêm domain prod mới (nếu có) vào PROD_HOSTS.
 */
const PROD_HOSTS = ['anthu.vn'];

const hostOf = (url?: string) => {
  try {
    return new URL(url || '').hostname.replace(/^www\./, '');
  } catch {
    return '';
  }
};

export const SEO_INDEXABLE = PROD_HOSTS.includes(hostOf(process.env.APP_URL));

export const ROBOTS_INDEX = 'index,follow,max-snippet:-1,max-image-preview:large';
export const ROBOTS_NOINDEX = 'noindex,nofollow,noarchive,nosnippet,noimageindex';
